import { DEFAULT_NO_EMAIL_BASE } from "@covertree/consts";

export function determineIfNoEmailAddress(
  emailAddress?: string | null,
  contactPhoneNumber?: string | null
): boolean {
  return (
    !!contactPhoneNumber &&
    !!emailAddress?.includes(DEFAULT_NO_EMAIL_BASE) &&
    !!emailAddress?.includes(contactPhoneNumber)
  );
}
